import { render, staticRenderFns } from "./FirstAccess.vue?vue&type=template&id=c63814ba&scoped=true"
import script from "./FirstAccess.vue?vue&type=script&lang=js"
export * from "./FirstAccess.vue?vue&type=script&lang=js"
import style0 from "./FirstAccess.vue?vue&type=style&index=0&id=c63814ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63814ba",
  null
  
)

export default component.exports